export default class QuestionAnswer {
    constructor($view) {
        this.$view = $view;
        this.bind();
    }

    bind() {

        // put an unique value .accordion id and as .collapse data-parent
        const accordion = this.$view.find('.accordion').first();
        const btn = this.$view.find('.btn').first();
        const collapse = this.$view.find('.collapse').first();
        const rand = Math.floor(Math.random() * 1000);
        $(accordion).attr('id', 'accordion-' + rand);
        $(btn).attr('data-target', '#collapse-' + rand);
        $(collapse).attr('id', 'collapse-' + rand);
        $(collapse).attr('data-parent', '#accordion-' + rand);

        // au chargement de la page, on ferme tous les éléments .collapse
        this.$view.find('.collapse').each(function() {
            $(collapse).removeClass('show');
            $(btn).attr('aria-expanded', 'false');
        });

        // Gérer le collapse manuellement
        btn.on('click', function (e) {
          e.preventDefault();
          const isExpanded = $(collapse).attr('aria-expanded', 'true');

          if (isExpanded) {
              $(btn).attr('aria-expanded', 'false');
          } else {
              $(btn).attr('aria-expanded', 'true');
          }
        });

    }
}
